export * from './car-miniature-img.component';
